import { render, staticRenderFns } from "./ActivityLogListItem.vue?vue&type=template&id=673b2811"
import script from "./ActivityLogListItem.vue?vue&type=script&lang=js"
export * from "./ActivityLogListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports